itsoftApp.createModule('loadingSliders', ['slidersLibrary', 'slidersSettings'], function () {
    let module = this;

    const loadingSliders = function () {
        const sliders = document.querySelectorAll('.js-slider');

        sliders.forEach(slider => {
            const sliderSettingsKey = slider.getAttribute('data-slider-settings'); // получаем data-атрибут
            const {sliderSettingsObject} = itsoftApp.modules.slidersSettings; // получаем объект конфига (общий)
            const params = sliderSettingsObject[sliderSettingsKey]; // Объект params, содержит любые поля + params с конфигом

            if (sliderSettingsKey && params) {
                itsoftApp.modules.slidersLibrary.callback(slider, {sliderSettings: params.params});
            } else {
                itsoftApp.modules.slidersLibrary.callback(slider);
            }
        });
    };

    loadingSliders();
    module.callback = loadingSliders;
});
